import { render, staticRenderFns } from "./immuneAgePdf.vue?vue&type=template&id=7f1b3670&scoped=true&"
import script from "./immuneAgePdf.vue?vue&type=script&lang=js&"
export * from "./immuneAgePdf.vue?vue&type=script&lang=js&"
import style0 from "./immuneAgePdf.vue?vue&type=style&index=0&id=7f1b3670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1b3670",
  null
  
)

export default component.exports